// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c0b021d","239":"5be69ec9","453":"2795d63c","455":"75f79d86","952":"773db289"}[chunkId] + ".chunk.js";
};